/**
 * Surface styling shared by every nudge chrome (card, collapsed row, and the standard body).
 *
 * Colors are Colib semantic tokens so the floating card flips with `.dark`; the card stays opaque
 * because it floats over arbitrary page content.
 */
export const NUDGE_SURFACE = {
  /** Card and collapsed-row shell: border, background, radius. */
  shell: 'rounded-2xl border border-border border-solid bg-card text-card-foreground',
  /** Elevation for the expanded card. */
  shadow: 'shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1)]',
  /** Lighter elevation for a collapsed row, which sits behind the expanded card. */
  shadowCollapsed: 'shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05)]',
  /** Inner padding of the expanded card. */
  padding: 'p-[14px]',
  /** Title / primary text. */
  title: 'text-card-foreground',
  /** Secondary text and muted controls, such as the description and the close button. */
  muted: 'text-muted-foreground',
  /** Hover fill for the clickable parts of the card. */
  hover: 'hover:bg-muted',
} as const;
